// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import 'iview/dist/styles/iview.css';    // 使用 CSS
import axios from 'axios'
import qs from 'qs';

Vue.prototype.$qs=qs;
Vue.prototype.$axios = axios;
// Vue.prototype.$ajax = axios
Vue.config.productionTip = false
Vue.use(iView);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
router.afterEach((to,from,next) => {

  window.scrollTo(0,0);

})


// WEBPACK FOOTER //
// ./src/main.js